import script from "./Treatment-big.vue?vue&type=script&setup=true&lang=js"
export * from "./Treatment-big.vue?vue&type=script&setup=true&lang=js"

import "./Treatment-big.vue?vue&type=style&index=0&id=91f2fb52&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-91f2fb52"]])

export default __exports__